import { Injectable } from '@angular/core';

import { CalendarEvent } from 'src/index';

import { EventsService } from 'src/core/index/services.index';

@Injectable({
    providedIn: 'root'
})
export class EventsServiceCustom extends EventsService {
    override eventsColorMap = new Map<string, string>([
        ["CLARIN-IT", "#07426E"],
        ["DARIAH-IT", "#006699"],
        ["E-RIHS.IT", "#EA212D"],
        ["OPERAS-IT", "#6A2462"],
        ["H2IOSC", "#004494"]
    ]);
    override getPropForColorMapping(event: CalendarEvent) {
        return event.infrastructure;
    }
}